class MediaQueryManager {
  constructor() {
    this.mediaQueries = {
      xLaptop: window.matchMedia('(max-width: 1330px)'),
      laptop: window.matchMedia('(max-width: 1024px)'),
      tablet: window.matchMedia('(max-width: 768px)'),
      mobile: window.matchMedia('(max-width: 600px)'),
    };

    this.listeners = new Set();

    this._handleMediaChange = this._handleMediaChange.bind(this);
    Object.values(this.mediaQueries).forEach((mq) => {
      mq.addEventListener('change', this._handleMediaChange);
    });
  }

  _handleMediaChange() {
    const state = this.getCurrentState();
    this.listeners.forEach((listener) => listener(state));
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  getCurrentState() {
    return {
      isXLaptop: this.mediaQueries.xLaptop.matches,
      isLaptop: this.mediaQueries.laptop.matches,
      isTablet: this.mediaQueries.tablet.matches,
      isMobile: this.mediaQueries.mobile.matches,
    };
  }
}

const globalMediaQueryManager = new MediaQueryManager();
export default globalMediaQueryManager;
